<template>
  <div v-if="data" class="contentful-cta" :class="['align-' + data.align, 'mw-adjusted-align-' + data.align]">
    <div class="title no-transform align ctf-body" v-if="data.showTitle">{{ data.title }}</div>
    <div class="button-text align ctf-body">
      <a
        :href="data.url"
        :target="hrefTarget"
        :class="[data.style !== 'link' && 'button', data.style, data.colour, data.size, data.fullWidthOnMobile && 'full-width-mobile']"
        :style="`color: ${data.fontColour}`"
      >
        {{ data.buttonText }}</a
      >
    </div>
  </div>
</template>

<script>
import { useContentful, contentfulProps } from '@/compositions/useContentful.js';
import { computed } from 'vue';
import UrlUtils from '@/pixel/utils/UrlUtils';

export default {
  props: contentfulProps,
  async setup(p, c) {
    const { data, init } = useContentful('pageComponentCtaButton', p, c);

    const hrefTarget = computed(() => {
      if (data.value?.openInNewTab !== null && typeof data.value?.openInNewTab !== 'undefined') {
        return data.value?.openInNewTab ? '_blank' : '_self';
      } else {
        if (data.value?.url !== null && typeof data.value?.url !== 'undefined') {
          return UrlUtils.isStorefrontUrl(data.value?.url) ? '_self' : '_blank';
        }
        else {
          return '_self';
        }
      }
    });
    await init();
    return { data, hrefTarget };
  },
};
</script>

<style lang="postcss">
@import '@/pixel/style/variables';

.contentful-cta {
  &.align-center {
    text-align: center;
  }
  &.align-right {
    text-align: right;
  }
  &.align-left {
    text-align: left;
  }
}
.button {
  font-size: inherit;
  padding: 0.75em 1.5em !important;
  border-radius: 10000px;
}
.button-text {
  margin-top: var(--space-4);
  margin-bottom: var(--space-4);

  /* purgecss ignore */
  a.full-width-mobile {
    @media (max-width: calc($mobile-breakpoint + 1px)) {
      display: block;
    }
  }

  a.link {
    text-decoration: underline;
    font-size: inherit;
    padding: 0;

    &.coral {
      color: var(--coral);
      /* purgecss ignore */
      &:hover {
        color: var(--coral-dark);
        text-decoration: none;
      }
    }

    &.white {
      color: var(--white);
      text-transform: none;
      text-decoration: underline;
      background: transparent;
      /*border: 1px solid transparent;*/

      &:hover {
        text-decoration: none;
        background: rgba(255, 255, 255, 0);
      }
    }
    &.small {
      font-size: 0.75em;
    }
    &.tiny {
      font-size: 0.5em;
    }
  }
}
</style>
